
import React, { useEffect } from 'react';
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { CreateSubscriptionService } from '../../services/AdminService';

function PaypalElement({ subscriptionData, setShowPaymentModal, setShowStatusModal }) {
    const handlePaymentCancel = () => setShowPaymentModal(false);

    const ButtonWrapper = ({ type }) => {
        const [{ options }, dispatch] = usePayPalScriptReducer();

        useEffect(() => {
            dispatch({
                type: "resetOptions",
                value: {
                    ...options,
                    intent: "subscription",
                },
            });
        }, [type]);

        return (
            <PayPalButtons
                createSubscription={(data, actions) => {
                    return actions.subscription
                        .create({
                            plan_id: subscriptionData?.paypalPriceId,
                        })
                        .then((subscriptionId) => {
                            return subscriptionId;
                        }).catch((error) => {
                            console.error("Create Subscription API Error:", error);
                        });
                }}
                style={{
                    label: "subscribe",
                }}
                onApprove={(data, actions) => {
                    return actions.subscription.get().then((details) => {
                        // console.log("Subscription approved!", details);
                        CreateSubscriptionService({
                            priceId: details.plan_id,
                            subscriptionId: details.id,
                            type: "paypal"
                        }, (res) => {
                            if (res.status === 200) {
                                // console.log("create Subscription Data==>", res.data);
                                if (res.data.success) {
                                    handlePaymentCancel();
                                    setShowStatusModal({ isOpen: true, type: "success" });
                                } else {
                                    handlePaymentCancel();
                                    setShowStatusModal({ isOpen: true, type: "failure" });
                                }

                            } else {
                                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                            }
                        });
                    }).catch((error) => {
                        handlePaymentCancel();
                        setShowStatusModal({ isOpen: true, type: "failure" });
                        console.error("Error in subscription approval", error);
                    });
                }}
                onCancel={() => {
                    console.warn("Subscription cancelled by user.");
                }}
                onError={(err) => {
                    console.error("PayPal Subscription Error:", err);
                    handlePaymentCancel();
                    setShowStatusModal({ isOpen: true, type: "failure" });
                }}
            />);
    }
    // console.log(subscriptionData)
    // console.log(process.env.REACT_APP_PAYPAL_CLIENT_ID)
    return (
        <ButtonWrapper type="subscription" />
    )
}

export default PaypalElement;